import { Versions } from "ftl-core";
const apiBaseUrl = process.env.REACT_APP_FTL_AUTH_BASE_URL
    ? process.env.REACT_APP_FTL_AUTH_BASE_URL
    : "http://localhost:42069";
export { apiBaseUrl as API_BASE_URL };
const baseUrl = `${apiBaseUrl}/not-secure/api/${Versions.v1}`;
export { baseUrl as BASE_URL };
const AuthRouter = {
    base: `${baseUrl}`,
    checkAvailable: `${baseUrl}/credentials/check-available`,
    init: `${baseUrl}/credentials`,
};
export default AuthRouter;
//# sourceMappingURL=AuthRouter.js.map